var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTableView',{attrs:{"head":_vm.tableHead}},_vm._l((_vm.employees),function(employee,key){return _c('EmployeesListItem',{key:key,attrs:{"employee":employee}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }